import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import type { ReactNode } from 'react';

import { buildClient } from './queryClient';

/**
 * Puts one query client above the application.
 *
 * <p>What that client decides lives in `./queryClient`, not here — a file exporting both a
 * component and a plain function loses fast refresh, and the defaults are worth reading on
 * their own and worth a test being able to hold the real ones rather than a bare client.
 */
export function QueryProvider({ children }: { children: ReactNode }) {
  // In state, not module scope: a client created at module scope is shared by
  // every test in a file, so one test's cache answers the next test's query.
  const [client] = useState(buildClient);

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
